import {useContext} from 'react';
import {I18n} from '@aws-amplify/core';

import {SimplePageHeader,} from '@flexinet/ui-components';
import {useVerifiedPermissions} from '@flexinet/auth-components';
import {rbacActions} from "../../../config/rbac/actions.ts";
import {ReloadRecordsButton} from '../buttons/ReloadRecordsButton.tsx';
import {FilterRecordsButton} from '../buttons/FilterRecordsButton.tsx';
import {DeleteRecordButton} from "../buttons/DeleteRecordButton.tsx";
import {AddRecordButton} from "../buttons/AddRecordButton.tsx";
import { GenerateProductFeaturesButton } from '../../test-data-generator/buttons/GenerateProductFeaturesButton.tsx';
import {moduleConfig} from "../config";
import {AuthContext} from '../../../context/AuthContext';
import {stage} from '../../../config/stage';
import {canGenerateTestData} from '../../reports/utils/testDataGeneration';

const useTools = () => {
    const {allowedActions} = useVerifiedPermissions();
    const {role} = useContext(AuthContext);

    const tools = [<FilterRecordsButton key='filter'/>, <ReloadRecordsButton key='reload'/>];

    if (allowedActions.includes(rbacActions.DeleteProductFeature)) {
        tools.push(<DeleteRecordButton key='delete'/>);
    }

    if (allowedActions.includes(rbacActions.CreateProductFeature)) {
        tools.push(<AddRecordButton key='add'/>);
    }

    // Test data is a dev/test capability for admins only: absent in prod, where the
    // generated rows would be indistinguishable from real ones (canGenerateTestData).
    if (allowedActions.includes(rbacActions.CreateProductFeature) && canGenerateTestData(stage, role)) {
        tools.push(<GenerateProductFeaturesButton key='generate'/>);
    }

    return tools;
};

export const IndexPageHeader = () => {
    return (
        <SimplePageHeader
            title={I18n.get(moduleConfig.titles.plural)}
            tools={useTools()}
        />
    );
};
